// test1859
(1859 && 0);
